import React from 'react';

import { Button } from '@components/Button';
import {
  ActionableDialog,
  ActionableDialogActions,
  ActionableDialogContent,
  ActionableDialogTitle,
} from '@components/Dialog';
import { userStrings } from '@data/user';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: 'D2D会員情報の変更',
  },
});

const useStyles = makeMuiStyles((_theme, common) => ({
  paper: {
    maxWidth: '681px',
  },
  dialogContent: {
    ...common.middleText,
    height: '80px',
    padding: '18px 0',
  },
  button: {
    width: '106px',
  },
}));

export interface EmailDuplicatedDialogProps {
  open: boolean;
  onClose: () => any;
}

export const EmailDuplicateDialog: React.FC<EmailDuplicatedDialogProps> = (props) => {
  const { open, onClose } = props;
  const classes = { ...useStyles(), ...useCommonStyles() };

  return (
    <ActionableDialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <ActionableDialogTitle>{strings.title}</ActionableDialogTitle>
      <ActionableDialogContent>
        <div className={classes.dialogContent}>{userStrings.emailDuplicate}</div>
      </ActionableDialogContent>
      <ActionableDialogActions justifyContent="center">
        <Button
          className={classes.button}
          color="primary"
          size="small"
          text={formStrings.ok}
          type="button"
          shape="round"
          onClick={onClose}
        />
      </ActionableDialogActions>
    </ActionableDialog>
  );
};
